/*
|---------------------------------------------------------------------
| Board Vuex State
|---------------------------------------------------------------------
|
| Kanban board initial cards state from content demo
|
*/
export default {
    // KANVAN
    cards: null,
    states: null,

    // USERS
    users: null,

    // CLIENTS
    clients: null,
    reverseMSG: false
}
